export default "__VITE_ASSET__BY1P11zW__"